module.exports = __webpack_public_path__ + "static/media/splat_small.b92ffbb0.png";